"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var appBuilder;
        (function (appBuilder) {
            var icons;
            (function (icons) {
                class InitArgs {
                    constructor() {
                        this.canSave = false;
                        this.iconInfoList = [];
                    }
                }
                let _initArgs;
                let _currentIconSet = appn.emptyString;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    appn.filesUploading = 0;
                    appn.icons.init();
                    appn.minicolors.init(function () {
                        if ($('#colorPreview').length) {
                            const picker = String(this.id);
                            (picker.containsIgnoreCase('Background')) ? appn.minicolors.refreshPreviewBody() : appn.minicolors.refreshPreviewTitle();
                        }
                    }, args.canSave);
                }
                icons.init = init;
                function addEvents() {
                    _currentIconSet = String($('#AppConfig_IconSet').val());
                    if (_currentIconSet === 'undefined')
                        _currentIconSet = 'Default';
                    $('#AppConfig_IconSet').change(function () {
                        const newIconSet = $(this).val();
                        $('.fileinput-new.thumbnail img').each(function () {
                            const bgImg = $(this).attr('src');
                            const bgImglazy = $(this).data('imglazyurl');
                            if (!bgImg.containsIgnoreCase('Files/Provider')) {
                                const iconName = $(this).closest('.iconInfo').data('icon');
                                let oldPath = _currentIconSet;
                                let oldBgUrl = `Content/icons/${_currentIconSet}`;
                                if (_currentIconSet === 'Default') {
                                    oldPath = findIconWithName(_initArgs.iconInfoList, iconName).path;
                                    if (oldPath.containsIgnoreCase('Files/'))
                                        oldBgUrl = oldPath;
                                    else
                                        oldBgUrl = 'Content/icons/' + oldPath;
                                }
                                let newPath = newIconSet;
                                let newBgUrl = `Content/icons/${newIconSet}`;
                                if (newIconSet === 'Default') {
                                    newPath = findIconWithName(_initArgs.iconInfoList, iconName).path;
                                    if (newPath.indexOf('Files/') >= 0)
                                        newBgUrl = newPath;
                                    else
                                        newBgUrl = 'Content/icons/' + newPath;
                                }
                                $(this).attr('src', bgImg.replace(oldBgUrl, newBgUrl));
                                $(this).attr('data-imglazyurl', bgImglazy.replace(oldBgUrl, newBgUrl));
                            }
                        });
                        _currentIconSet = newIconSet;
                    });
                    $('.iconReset').on('click', function (event) {
                        event.preventDefault();
                        const iconPath = $(this).closest('.iconInfo').find('input.iconPath');
                        const iconName = $(this).closest('.iconInfo').data('icon');
                        let newPath = _currentIconSet;
                        if (_currentIconSet === 'Default')
                            newPath = findIconWithName(_initArgs.iconInfoList, iconName).path;
                        newPath = String(iconPath.val()).replace(`Files/Provider/${appn.requestProvider.id}`, newPath);
                        if (newPath.containsIgnoreCase('sys_'))
                            newPath = newPath.replace('sys_', appn.emptyString);
                        iconPath.val(newPath);
                        if (!newPath.containsIgnoreCase('Files/'))
                            newPath = 'Content/icons/' + newPath;
                        $(this).closest('.fileinput')
                            .find('.thumbnail')
                            .find('img')
                            .attr('src', appn.urls.root + newPath);
                        $(this).hide();
                    });
                    $('.iconUpload').fileupload({
                        dataType: 'json',
                        change: function (event, data) {
                            const file = data.files[0];
                            const isValidExt = appn.utils.isValidFileExtension(['.png'], file.name);
                            const isValidSize = appn.utils.IsValidFileSize(50, file);
                            if (!isValidExt || !isValidSize) {
                                const that = this;
                                setTimeout(function () {
                                    $(that).closest('.fileinput').find('.btn.fileinput-exists.btn-remove').click();
                                }, 500);
                            }
                            return isValidExt && isValidSize;
                        },
                        submit: function (event, data) {
                            data.formData = {
                                iconname: $(this).closest('.iconInfo').data('icon'),
                                icontype: $(this).closest('.iconInfo').data('icontype')
                            };
                        },
                        send: function () {
                            appn.filesUploading++;
                        },
                        always: function () {
                            appn.filesUploading--;
                        },
                        done: function (event, data) {
                            if (data.result.error) {
                                appn.fileUploadUtils.fileUploadFailed(data.result.error);
                                return;
                            }
                            $(this).closest('.iconInfo').find('input.iconPath').val(data.result);
                        },
                        error: function () {
                            appn.fileUploadUtils.fileUploadFailed();
                        },
                        fail: function (event, data) {
                            appn.fileUploadUtils.fileUploadFailed();
                        }
                    });
                }
                function findIconWithName(array, name) {
                    return array.filter(t => t.name === name)[0];
                }
            })(icons = appBuilder.icons || (appBuilder.icons = {}));
        })(appBuilder = views.appBuilder || (views.appBuilder = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
